import * as React from "react";
import Box from "@material-ui/core/Box";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../store/root-reducer";
import {AuthMeModel} from "../../models/auth-me.model";
import {AccountTypeEnum} from "../../models/account-type.enum";
import styled from "styled-components";
import {Colors} from "../../theme/colors";
import {Dialog, DialogContent, Grid, Hidden, List, SwipeableDrawer, Tooltip} from "@material-ui/core";
import {useEffect} from "react";
import {hideMenu, openMenu} from "../../store/global/global-slice";
import {NavLink} from "react-router-dom";
import logo from "../../img/logo.png";
import logoMobile from "../../img/logo-mobile.png";
import {HelpOutline} from "@material-ui/icons";
import helpInfo from "../../img/help-info.jpeg";
import {CustomCloseModalIcon} from "./icons/custom-close-modal-icon";
import {NotAccessModal} from "./not-access-modal";
import {useTranslation} from "react-i18next";
import {CustomSidebarBackgroundIcon} from "./new-icons/custom-sidebar-background-icon";
import {AuthorMenu, IMenuOption} from "./menus/author-menu";
import {PublisherMenu} from "./menus/publisher-menu";
import {StyledP1} from "./styles";
import * as H from "history";


export const Sidebar: React.FC<any> = () => {
    const [openNotAccess, setOpenNotAccess] = React.useState<boolean>(false);
    const [openHelpDialog, setOpenHelpDialog] = React.useState<boolean>(false);
    const [menu, setMenu] = React.useState<IMenuOption[]>([]);
    const dispatch = useDispatch();
    const {t} = useTranslation('common');

    const authMe: AuthMeModel = useSelector(
        (state: RootState) => state.auth.user
    );

    const menuIsOpen = useSelector(
        (state: RootState) => state.global.showMenu
    );

    useEffect(() => {
        if (window.innerWidth < 959) {
            dispatch(hideMenu());
        }

        if (window.innerWidth > 959) {
            dispatch(openMenu());
        }

        window.addEventListener('resize', () => {
            if (window.innerWidth < 959 && menuIsOpen) {
                dispatch(hideMenu());
            }

            if (window.innerWidth > 959 && !menuIsOpen) {
                dispatch(openMenu());
            }
        });
    }, [dispatch, menuIsOpen]);

    useEffect(() => {
        if (authMe && authMe.account_type === AccountTypeEnum.AUT) {
            setMenu(AuthorMenu);
        }
        if (authMe && authMe.account_type === AccountTypeEnum.PUB) {
            setMenu(PublisherMenu);
        }
    }, [authMe]);

    const checkPermissions = (event, permission: string) => {
        if (permission) {
            const allowed = authMe?.subscription?.features.find((feature) => feature === permission);

            if (!allowed) {
                event.preventDefault();
                setOpenNotAccess(true);
            }
        }
    }

    return (
        <>
            <DrawerStyled
                variant="persistent"
                anchor="left"
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
                open={true}
                disableBackdropTransition={true}
                onClose={() => {
                }}
                onOpen={() => {
                }}
                style={{width: (menuIsOpen) ? '250px' : '60px'}}
            >
                <StyledBoxSidebar
                    style={{overflowX: 'hidden'}}
                    display={'flex'}
                    flexDirection={'column'}
                >

                    <StyledLogoBox
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                    >
                        <Hidden smDown>
                            <img src={logo} alt={'Logo'}/>
                        </Hidden>

                        <Hidden mdUp>
                            <img src={logoMobile} alt={'Logo'}/>
                        </Hidden>
                    </StyledLogoBox>

                    <Box
                        display={'flex'}
                        flex={0}
                        flexDirection={'column'}
                        style={{zIndex: 1}}
                    >
                        {menuIsOpen &&
                            <Box flexDirection={"column"}>
                                {menu.map((menuOption, index) => (
                                    <StyledMenuLinkBox key={index} display="flex">
                                        <NavLink to={menuOption.link}
                                                 isActive={(match, location) => {
                                                     return !!menuOption.matchUrl.find(url => location.pathname.search(url) !== -1);
                                                 }}
                                                 activeClassName="active"
                                                 onClick={(event) => {
                                                    checkPermissions(event, menuOption.permission)
                                        }}>
                                            {menuOption.icon()}
                                            <StyledP1>{t(menuOption.label)}</StyledP1>
                                        </NavLink>
                                    </StyledMenuLinkBox>
                                ))}

                                {authMe && authMe.account_type === AccountTypeEnum.PUB && authMe.language === 'pl' ?
                                    <>
                                        <StyledMenuLinkBox display="flex" className="help-link">
                                            <NavLink activeClassName="non-active" to="#" onClick={() => {
                                                setOpenHelpDialog(true)
                                            }}>
                                                <HelpOutline style={{color: Colors.neutral90, width: '24px', height: '24px'}}/>
                                                <StyledP1 style={{color: Colors.neutral98}}>{t('menu.info')}</StyledP1>
                                            </NavLink>
                                        </StyledMenuLinkBox>

                                        <DialogStyled fullScreen open={openHelpDialog}>
                                            <DialogContent
                                                style={{padding: 0, maxHeight: '100%', background: 'transparent'}}>
                                                <Grid container direction={"row"} justifyContent={"center"}
                                                      style={{maxHeight: '100vh'}}>
                                                    <div style={{position: 'relative'}}>
                                                        <img style={{maxHeight: '100vh'}} src={helpInfo} alt={'help'}/>
                                                        <StyledCloseButton onClick={() => {
                                                            setOpenHelpDialog(false)
                                                        }}>
                                                            <CustomCloseModalIcon/>
                                                        </StyledCloseButton>
                                                    </div>
                                                </Grid>
                                            </DialogContent>
                                        </DialogStyled>
                                    </>
                                    : ''}
                            </Box>
                        }

                        {!menuIsOpen &&
                            <List>
                                {menu.map((menuOption, index) => (
                                    <Tooltip key={index} title={t(menuOption.label)}>
                                        <StyledMenuMobileLinkBox display="flex">
                                            <NavLink to={menuOption.link}
                                                     isActive={(match, location) => {
                                                         return !!menuOption.matchUrl.find(url => location.pathname.search(url) !== -1);
                                                     }}
                                                     activeClassName="active"
                                            >
                                                {menuOption.icon()}
                                            </NavLink>
                                        </StyledMenuMobileLinkBox>
                                    </Tooltip>
                                ))}
                            </List>
                        }
                    </Box>

                    <Hidden smDown>
                        <StyledSidebarBackgroundIcon/>
                    </Hidden>
                </StyledBoxSidebar>
            </DrawerStyled>

            <NotAccessModal open={openNotAccess} setOpen={setOpenNotAccess}/>
        </>
    );
}

const StyledLogoBox = styled(Box)`
  padding: 24px;
  width: 100%;

  img {
    height: 42px;
  }

  @media (max-width: 959px) {
    padding: 10px;
  }
`;

const StyledSidebarBackgroundIcon = styled(CustomSidebarBackgroundIcon)`
  width: 193px;
  height: 366px;
  position: fixed;
  bottom: 0;
  left: 56px;
  z-index: 0;
`

const StyledBoxSidebar = styled(Box)`
  position: relative;
  height: 100%;
  background: linear-gradient(54deg, rgba(151, 71, 255, 0.25) 0%, rgba(151, 71, 255, 0.00) 100%), #340F57;
`;

const StyledMenuLinkBox = styled(Box)`
  margin: 0 10px 8px;

  a {
    border-radius: 12px;
    padding: 0.63rem 1rem;
    width: 100%;
    margin: 0 auto;
    flex-direction: row;
    align-items: center;
    display: flex;

    p {
      color: ${Colors.neutral98};
    }

    svg {
      color: ${Colors.secondary90};
      margin-right: 0.5rem;
    }

    &.active {
      background-color: ${Colors.primary70};

      p, svg {
        color: ${Colors.neutral10} !important;
      }
      
      p {
        font-weight: 400;
      }
    }
  }

  &.help-link {
    a.active {
      background-color: transparent;
      
      p {
        color: #FFFFFF;
      }
    }
  }
`;

const StyledMenuMobileLinkBox = styled(Box)`
  margin: 0 10px 8px;

  a {
    border-radius: 12px;
    padding: 0.63rem 0;
    width: 100%;
    margin: 0 auto;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    display: flex;

    p {
      color: ${Colors.neutral98};
    }

    svg {
      color: ${Colors.secondary90};
    }

    &.active {
      background-color: ${Colors.primary70};

      p, svg {
        color: ${Colors.neutral10} !important;
      }
      
      p {
        font-weight: 400;
      }
    }
  }

  &.help-link {
    a.active {
      background-color: transparent;
      
      p {
        color: #FFFFFF;
      }
    }
  }
`;

const DrawerStyled = styled(SwipeableDrawer)`
  flexShrink: 0;
  position: relative;
  overflow-x: hidden;
  height: 100%;
  border-right: 0;
  z-index: 1;
`;

const DialogStyled = styled(Dialog)`

  .MuiPaper-root {
    background-color: transparent;
  }
`;

const StyledCloseButton = styled('div')`
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;

  svg {
    background: #fff;
    border-radius: 101%;
    border: 1px solid #ccc;
  }
`;
